import TableVM from '../table-vm';
export default Kadenze.Util.extendObj(TableVM, function(coursework_id) {
  var self = this;
  self.$el = $('#analytics-tab-content');
  self.request_pool = new Kadenze.AjaxRequestPool();
  self.stats = ['submission_rate', 'graded', 'lowest_score', 'median_score', 'highest_score'];
  self.coursework_id = ko.observable();
  self.coursework = ko.observable();

  self.initUI = function() {

  };

  self.filterChanged = function () {
    self.$el.click(); //Hack to close selectpicker & menus
    self.request_pool.abortAll();
    self.showPlaceholder('loading');
    self.getCoursework();
  };

  self.getCoursework = function() {
    var url = Kadenze.Routes.show_course_gradebook_analytics_path(self.course_id, 'coursework', self.coursework_id());

    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      data: null,
      timeout: 60000
    });

    request.done(function(data) {
      var mapped_coursework = ko.mapping.fromJS(data);
      self.coursework(mapped_coursework);

      _.each(self.stats, function (stat) {
        self.createRingChart('.js-donut-' + stat.replace('_','-'), self.coursework()[stat]());
      });

      self.hidePlaceholder();
    });

    request.fail(function(data) {
      console.log('Error retrieving row data:', data);
    });
  };

  self.exportTable = function () {
    var url = Kadenze.Routes.export_course_gradebook_analytics_path(self.course_id, {subject: 'coursework', subject_id: self.coursework_id()});
    window.open(url, '_blank');
    Kadenze.Analytics.track('grade', 'download', {type: 'coursework_analytics', coursework_id: self.coursework_id()});
  };

  const __construct = function(that) {
    console.log('constructor called for InstructorGradebook.Coursework.AnalyticsVM');
    that.course_id = $('#course_id').val();

    that.coursework_id.subscribe(that.filterChanged);
    that.coursework_id(coursework_id);
  }(this);
});

